<div class="flex flex-auto w-full min-w-80 h-50 p-4" [class.overflow-auto]="overflowAuto">
  <div class="flex flex-col flex-auto">
    <div class="mt-auto">
      <ts-table
        [columnDefs]="columnDefs"
        [hasActionsColumn]="false"
        [rowData]="rowData"
        (onColumnMove)="columnMoved.emit($event)"
      ></ts-table>
    </div>
  </div>
</div>
